"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var _componentUtils = require("../../common/componentUtils");
const _excluded = ["img", "mobileImg"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list;
  const handledLogoList = list === null || list === void 0 ? void 0 : list.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      img = _ref2.img,
      mobileImg = _ref2.mobileImg,
      other = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    return _objectSpread(_objectSpread({}, other), {}, {
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileImg || '').url
    });
  });
  return {
    porintId,
    tag: tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    list: handledLogoList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const heroData = formatAdvantageCommon(data, {
      domains
    });
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: heroData === null || heroData === void 0 ? void 0 : heroData.porintId,
      className: "gems-materials-qci__newUI-introCard"
    }, (0, _reportUtil.reportShow)(['show_newUI_IntroCard', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: heroData === null || heroData === void 0 ? void 0 : heroData.tag,
      title: (heroData === null || heroData === void 0 ? void 0 : heroData.title) || '',
      desc: (heroData === null || heroData === void 0 ? void 0 : heroData.desc) || '',
      bg: heroData === null || heroData === void 0 ? void 0 : heroData.bg,
      bgColor: heroData === null || heroData === void 0 ? void 0 : heroData.bgColor,
      bgImg: heroData === null || heroData === void 0 ? void 0 : heroData.bgImg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.IntroCard, {
      data: heroData === null || heroData === void 0 ? void 0 : heroData.list
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}